<!-- @switch (displayTradePrice)  -->
<div [tradePricingMask]="[product]">
    @if(proPriceMode) {
    <p class="col-w c2">
        {{'PRO Price' | translate}}
    </p>
    }
    <!-- final price -->
    <price class="block h4"
           [value]="price"
           [ngClass]="proPriceMode ? 'col-7' : 'col-1'"></price>
    <!-- @if (product.orgPrice) {
    <price class="col-4 inline-block line-through va-m m-r-1"
           [sizeClass]="small ? 'SMXL: s2' : 'SM:s2, XL:s1'"
           [value]="product.orgPrice"></price>
    } -->
    <p class="c2"
       [ngClass]="proPriceMode ? 'col-w' : 'col-1'">
        {{'per %' | translate : (product.data.sunitdesc || ('Each' | translate))}}
        @if(!priceService.showCatalogPricesInclTax){
        {{'+VAT' | translate}}
        } @else {
        {{'(inc VAT)' | translate}}
        }
    </p>
</div>